import type { SigninTrackingPort } from '@cencosud-cencommerce/paris-login';

import { trackEvent } from './brazeClient';

export class BrazeSigninTrackingAdapter implements SigninTrackingPort {
  signinCompleted() {
    trackEvent('signin_completed');
  }
}
